<script setup lang="ts">
import CoreLoader from "@core/core-loader.vue";
import {useI18n} from "vue-i18n";
import {useVpnConnector} from "@composables/vpnConnector";
import {useRoute} from "vue-router";
import {computed, ref} from "vue";
import {AppType} from "@store/api/interfaces";
import ButtonPrimary from "@buttons/button-primary.vue";

const {t} = useI18n();
const vpnConnector = useVpnConnector();
const route = useRoute()
const botLink = computed(() => import.meta.env.VITE_BOT_LINK as string + "?startapp")

const app = ref<AppType | null>(route.params.app as AppType);

switch (app.value) {
  case 'streisand': vpnConnector.streisand.connect(); break;
  case 'v2box': vpnConnector.v2box.open(); break;
  case 'hiddify': vpnConnector.hiddify.open(); break;
  case 'v2ray_ng': vpnConnector.v2rayNg.open(); break;
  default: break;
}
</script>

<template>
  <main class="page vpn-page">
    <div class="wrapper vpn__section">
      <core-loader
          absolute
          :title="t('common.loader.open_vpn_app')"
      />
    </div>
    <div class="wrapper vpn__section vpn__section__button">
      <button-primary
          :url="botLink"
      >
        {{ t('common.buttons.return_to_bot') }}
      </button-primary>
    </div>
  </main>
</template>

<style lang="scss">
  .vpn {
    &-page {
      justify-content: space-between;
      height: 10vh;
    }

    &__section {
      flex: 1 auto;
      display: flex;
      flex-direction: column;

      &__button {
        flex: 0 0 auto;
        max-width: 500px;
      }
    }
  }
</style>
